import { DateTime } from "luxon";
import React from "react";
import { Updater, useImmer } from "use-immer";

import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";

import theme from "../../theme";

interface SimpleDateTimePickerProps {
  dateTime: DateTime | null;
  label?: string;
  onTimeChange: (newVal: DateTime | null) => void;
  resourceMinTime: DateTime;
  width?: string;
  minutesStep?: number;
  disabled?: boolean;
  setIsError?: Updater<boolean>;
}

export const SimpleDateTimePicker = ({
  dateTime,
  resourceMinTime,
  onTimeChange,
  label,
  disabled,
  width,
  minutesStep,
  setIsError,
}: SimpleDateTimePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DateTimePicker
        slotProps={{
          digitalClockSectionItem: {
            sx: {
              "&.Mui-selected": {
                backgroundColor: `${theme.palette.primary.main} !important`,
              },
            },
          },
        }}
        disablePast={true}
        closeOnSelect={false}
        disabled={disabled}
        sx={{ width: width || undefined }}
        minDateTime={resourceMinTime}
        label={label || "Select Time"}
        value={dateTime}
        minutesStep={minutesStep}
        onChange={(newValue) => {
          onTimeChange(newValue);
          if (setIsError) setIsError(false);
        }}
        onError={(newError) => {
          if (setIsError) setIsError(true);
        }}
      />
    </LocalizationProvider>
  );
};
